import { render, staticRenderFns } from "./HeadSection.vue?vue&type=template&id=4aa5d60a&scoped=true&"
import script from "./HeadSection.vue?vue&type=script&lang=js&"
export * from "./HeadSection.vue?vue&type=script&lang=js&"
import style0 from "./HeadSection.vue?vue&type=style&index=0&id=4aa5d60a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa5d60a",
  null
  
)

export default component.exports